import React, { ReactNode, useState } from "react";

interface DragTargetProps {
  dragId: string[];
  children: ReactNode;
  onDrop: (data: unknown) => void;
  className?: string;
}

export function DragTarget({
  dragId,
  children,
  onDrop,
  className = "",
}: DragTargetProps) {
  const [isDraggedOver, setIsDraggedOver] = useState(false);

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggedOver(true);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "move";
    if (!isDraggedOver) {
      setIsDraggedOver(true);
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;

    // Only set isDraggedOver to false if we've actually left the target
    if (
      x <= rect.left ||
      x >= rect.right ||
      y <= rect.top ||
      y >= rect.bottom
    ) {
      setIsDraggedOver(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggedOver(false);

    try {
      const sourceDragId = JSON.parse(
        e.dataTransfer.getData("application/drag-id")
      );
      if (dragId.some((id) => sourceDragId.includes(id))) {
        const data = JSON.parse(e.dataTransfer.getData("application/json"));
        onDrop(data);
      }
    } catch (error) {
      console.error("Error processing drop:", error);
    }
  };

  return (
    <div 
      className={`${className} ${isDraggedOver ? 'bg-blue-100 scale-[1.02]' : ''} transition-all duration-200`}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {children}
    </div>
  );
}
